import {appStore} from '@/entities/app';
import {boostStore} from '@/entities/boost';
import {discoveryStore} from '@/entities/discovery';
import {geoStore} from '@/entities/geo';
import {matchStore} from '@/entities/match';
import {notificationStore} from '@/entities/notification';
import {settingsStore} from '@/entities/settings';
import {userStore} from '@/entities/user';
import {DEBUG} from '@/shared/config';

if (DEBUG && typeof window !== 'undefined') {
  // Expose storages for debugging purposes
  (window as any).__debug = {
    storages: {
      discoveryStore,
      userStore,
      matchStore,
      geoStore,
      notificationStore,
      boostStore,
      appStore,
      settingsStore,
    },
  };
}
